import { DOCUMENT } from '@angular/common';
import { Injectable, inject, signal } from '@angular/core';

export type AppTheme = 'light' | 'dark';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly document = inject(DOCUMENT);
  private readonly storageKey = 'app-theme-preference';

  readonly currentTheme = signal<AppTheme>('light');

  initializeTheme(): void {
    const savedTheme = this.getSavedTheme();

    this.applyTheme(savedTheme ?? 'light');
  }

  toggleTheme(): void {
    const nextTheme: AppTheme = this.currentTheme() === 'light' ? 'dark' : 'light';

    this.setTheme(nextTheme);
  }

  setTheme(theme: AppTheme): void {
    localStorage.setItem(this.storageKey, theme);
    this.applyTheme(theme);
  }

  isDarkMode(): boolean {
    return this.currentTheme() === 'dark';
  }

  private applyTheme(theme: AppTheme): void {
    this.currentTheme.set(theme);

    this.document.documentElement.setAttribute('data-theme', theme);
    this.document.documentElement.setAttribute('data-bs-theme', theme);
  }

  private getSavedTheme(): AppTheme | null {
    const savedTheme = localStorage.getItem(this.storageKey);

    return savedTheme === 'light' || savedTheme === 'dark' ? savedTheme : null;
  }
}

// System according theme
/**import { DOCUMENT } from '@angular/common';
import { Injectable, OnDestroy, inject, signal } from '@angular/core';

export type AppTheme = 'light' | 'dark';

@Injectable({
  providedIn: 'root',
})
export class ThemeService implements OnDestroy {
  private readonly document = inject(DOCUMENT);
  private readonly storageKey = 'app-theme-preference';
  private systemThemeQuery: MediaQueryList | null = null;

  private readonly handleSystemThemeChange = (event: MediaQueryListEvent): void => {
    if (this.getSavedTheme() === null) {
      this.applyTheme(event.matches ? 'dark' : 'light');
    }
  };

  readonly currentTheme = signal<AppTheme>('light');

  initializeTheme(): void {
    const savedTheme = this.getSavedTheme();

    this.systemThemeQuery ??= window.matchMedia('(prefers-color-scheme: dark)');
    this.systemThemeQuery.addEventListener('change', this.handleSystemThemeChange);

    if (savedTheme !== null) {
      this.applyTheme(savedTheme);
      return;
    }

    this.applyTheme(this.systemThemeQuery.matches ? 'dark' : 'light');
  }

  toggleTheme(): void {
    const nextTheme: AppTheme = this.currentTheme() === 'light' ? 'dark' : 'light';

    this.setTheme(nextTheme);
  }

  setTheme(theme: AppTheme): void {
    localStorage.setItem(this.storageKey, theme);
    this.applyTheme(theme);
  }

  isDarkMode(): boolean {
    return this.currentTheme() === 'dark';
  }

  ngOnDestroy(): void {
    this.systemThemeQuery?.removeEventListener('change', this.handleSystemThemeChange);
  }

  private applyTheme(theme: AppTheme): void {
    this.currentTheme.set(theme);

    this.document.documentElement.setAttribute('data-theme', theme);
    this.document.documentElement.setAttribute('data-bs-theme', theme);
  }

  private getSavedTheme(): AppTheme | null {
    const savedTheme = localStorage.getItem(this.storageKey);

    return savedTheme === 'light' || savedTheme === 'dark' ? savedTheme : null;
  }
}
*/
